export const InvalidPolicyErrorName = 'InvalidPolicyError';
export default class InvalidPolicyError extends Error {
  constructor(policy, method) {
    super(`Method '${method}' cannot be called with policy '${policy}'.`);
    this.name = InvalidPolicyErrorName;
  }
}